const errorMessages = {
  default: 'Something went wrong. Please try again or contact support.',
  feature: {
    limits: {
      watermark: "Watermark removal is a paid feature. Upgrade your plan to enable it."
    }
  },
  payment: {
    default: 'Something went wrong. Please try again.',
    card: {
      default:
        'There was an error verifying card! Pleas try again. If this message persists please contact support.',
      threeDSecure: {
        default: 'There was an error verifying card with your Bank! Pleas retry or use another payment method.',
        cardNotFound: 'Please double check the information you have entered and try again.',
        validationError: 'Please double check the information you have entered and try again.',
        cardNotAcceptedByMerchant:
          'Credit card type is not accepted by this merchant account. Please contact support.',
      },
      hostedFields: {
        default: 'There was an error with processing your payment!. Please contact support.',
        fieldsEmpty: 'Card fields are empty! Please fill in your credit card information.',
        fieldsInvalid: 'Some of the supplied credit card information is invalid.',
        cardDuplicate:
          'This card has already been used on another account. Please add a different card or contact support to resolve the issue.',
        cvvVerificationFailed:
          'The card cvv has failed to pass verification. Please double check and try again.',
        tokenizationFailed: 'Please double check your card information and try again.',
        tokenizationNetworkError:
          'There seems to be a problem with your network connection. Please try again later.',
        cancelledByMerchant: 'The transaction has been denied. Please contact support.',
      },
    },
    payPal: {
      default: 'There was an error setting up PayPal. Please Try again or contact support.',
    },
  },
}

export { errorMessages }
